const data = [
  {
    id: '1',
    title: 'Java开发工程师',
    address: '深圳',
    positionTypeName: '技术',
    positionTypeCode: 'technology',
    duties: '1、参与公司企业级产品后端的研发，确保系统的安全、高可用性和可靠性；\n2、参与业务需求讨论，评审产品设计，驱动研发团队一起按时、高质量完成产品交付；\n3、负责公司企业应用平台的开发和部分架构设计，保证设计和编码的质量，主动承担重点、难点的技术攻坚。',
    ask: '1、计算机及其相关专业，本科及其以上学历，3年以上系统开发工作经验；\n2、熟悉Java语言、面向对象编程，理解设计模式，有扎实的编程能力和优雅的代码追求，热爱编程；\n3、对各种开源的框架如Spring Cloud、spring boot、Spring、SpringMVC、Mybatis等有多年开发经验，理解分布式服务框架，分布式缓存或者分布式锁的设计原理；\n4、熟练使用redis、rabbitMQ/kafka等中间件，并理解其原理；\n5、深刻理解计算机原理，有良好的数据结构和算法基础；\n6、较好的产品意识，愿意将产品效果做为工作最重要的驱动因素；\n7、对软件产品有强烈的责任心，具备良好的沟通能力和优秀的团队协作能力；\n8、积极乐观，认真负责，乐于协作。',
    pluses: ''
  },
  {
    id: '2',
    title: '前端开发工程师(移动端)',
    address: '深圳',
    positionTypeName: '技术',
    positionTypeCode: 'technology',
    duties: '1、负责公司移动端产品(h5/小程序/跨端)分析设计、开发实现和持续改善，优化应用程序及网站前端性能，提升用户体验；\n2、优化前端功能设计，解决主流浏览器及其不同版本之间的兼容性问题；\n3、通用组件、类库编写，提升开发效率和质量。',
    ask: '1、本科及以上学历，计算机相关专业；\n2、了解面向对象的思想，3年以上前端开发经验；\n3、精通使用react全家桶，熟练编写typescript/es6代码；\n4、熟悉前端主流框架，react和vue；\n5、有大量小程序开发经验、能熟练使用flutter/react navive其中一种；\n6、熟悉前端主流UI库；\n7、熟悉使用git，gitlab等git相关工具；\n8、对前端工程化有较深刻的认识，并能够熟练使用gulp/webpack/vite等相关工具；\n9、对模块化、组件化思想有较深刻的认识，有github开源项目者更佳；\n10、熟悉运维环境，对上线、部署、linux等有较好的理解。',
    pluses: ''
  },
  {
    id: '3',
    title: '测试工程师',
    address: '深圳',
    positionTypeName: '技术',
    positionTypeCode: 'technology',
    duties: '1、负责SaaS、金融、物流网平台等相关业务的测试；\n2、参与产品需求评审，分析并制定测试计划和策略，设计测试用例并组织、参与用例评审；\n3、执行测试用例，缺陷深入跟踪，并协助开发分析解决问题；\n4、跟进项目迭代，能预估风险，推进项目进度，保证项目质量。',
    ask: '1、本科以上学历，3-5年测试经验，有1年以上银行或互联网金融测试经验者优先；\n2、有较强的接口测试能力，熟悉jmeter,postman等测试工具；\n3、熟悉Oracle、mysql等常用的数据库，能熟练编写数据库查询语句；\n4、做事积极主动，责任心强，有良好的沟通能力、自学能力及独立解决问题的能力；\n5、能承担一定的工作压力，对学习新技术有浓烈的兴趣。',
    pluses: ''
  },
  {
    id: '4',
    title: '产品经理',
    address: '深圳',
    positionTypeName: '产品',
    positionTypeCode: 'product',
    duties: '1、在产品整体规划下，负责主业务流程的产品方案输出，包括对应的业务方案及系统方案；\n2、理解公司业务模式，产出对应的竞品报告及相关的模式分析；\n3、负责产品方案设计，输出产品原型、需求评审、技术方案审核、测试验收、上线等环节。同时负责产品全生命周期的跟进和推动。',
    ask: '1、本科及以上学历，3年及以上相关工作经验；\n2、熟悉产品整体生命周期，包括需求分析，方案设计，项目管理等；\n3、有供应链金融相关经验，有信贷产品相关经验优先；有金融领域的业务或者系统相关经验优先。',
    pluses: ''
  },
  {
    id: '5',
    title: '数字方案经理（IOT）',
    address: '深圳',
    positionTypeName: '数字评估',
    positionTypeCode: 'assessment',
    duties: '1、负责组织制定物联网项目的技术方案编写、讲解及用户答疑等工作；\n2、配合客户经理完成与用户的技术交流、技术方案宣讲、应用系统演示等工作；\n3、配合市场人员完成应用系统演示、产品宣传资料撰写等工作；\n4、配合做好与合作伙伴厂商的技术交流；\n5、负责输出产业互联网、工业互联网、农业物联网等细分行业的典型案例并形成方案库；\n6、做好方案品牌统一，协助市场推广部门对主渠道进行技术培训；\n7、负责项目的商务拓展、方案设计及实施推进，包括：需求调研和分析、解决方案及相关文档撰写（例如规划方案、技术方案、项目可行性分析报告、业务需求书）、客户现场讲解与沟通等；\n8、参与项目招投标工作，负责编写标书中与解决方案相关的内容、现场述标等。',
    ask: '1、统招本科及以上，计算机、软件、电子信息、物联网等相关专业毕业；2、熟悉计算机网络、通信网络技术以及软件系统的技术，有实际物联网领域数据采集相关系统集成项目的设计经验；\n3、较多的方案设计、标书应答、用户交流经验；\n4、良好的写作和口才；\n5、具备软件技术开发和工程实践者优先；\n6、工作条理性强，具有很强的责任心和团队合作精神，具备较强的协调能力；\n7、服从组织安排，能适应长期出差。',
    pluses: '1、熟练REST、MQTT、TCP/IP、Modbus等物联网常用协议；\n2、有工业、嵌入式开发等相关行业工作背景优先；\n3、熟悉常见工业现场协议优先。'
  },
  {
    id: '6',
    title: '风控经理',
    address: '深圳',
    positionTypeName: '风控',
    positionTypeCode: 'riskcontrol',
    duties: '1、结合公司合作的不同产业，建立并完善产业金融风险控制体系，制定统一的风险管理政策、制度和流程、指引；\n2、负责分析和识别金融项目的合规、市场、信用、运营等风险；\n3、制定贷前、贷中和贷后对应的执行方案；\n4、在运营过程中针对潜在风险点提出改进方案，优化风控方案；\n5、负责开展产业金融风险的前瞻性研究和风控项目实施，应对、处置各类复杂或突发风险事件。',
    ask: '1、本科以上学历，财经、金融、贸易、会计、财务管理或法律专业；\n2、5年以上产业金融风险运营经验；\n3、熟悉对公业务产品风险管理，并对线上信贷产品风险有深入了解；\n4、擅长数据分析，对数据有敏锐度，能够准确描述和识别作弊特征，擅长从大量信息中发掘有价值的关键点；\n5、有较强的风控控制意识和水平；\n6、有产业金融系统开发参与经验，B端客户评分评级模型主导或参与经验优先；\n7、能够独立完成尽职调研工作，能适应阶段性出差；\n8、为人正直，责任心较强，具备良好的沟通协调能力。',
    pluses: ''
  },
  {
    id: '7',
    title: '风控算法专家',
    address: '深圳',
    positionTypeName: 'AI',
    positionTypeCode: 'ai',
    duties: '1、基于金融业务的需要进行数据分析和建模工作；\n2、深入业务，理解并设计各项指标，建立各类机器学习模型所需要的数据框架；\n3、完成基于结构化数据的数据统计、汇总、分析、归纳等基础分析，并基于对数据分析及业务的理解，建立数据标签库和衍生变量库； \n4、负责灵活运用传统统计学模型和机器学习模型来完成金融建模任务，特别是风控算法模型建立和优化，支持业务决策；\n5、追踪业内前沿技术，结合业务特点，探索将前沿的算法技术应用于实际业务的可能；\n6、负责带领/指导其他其他分析师工作； \n7、完成上级交代的相关工作。',
    ask: '1、计量分析、数量经济学、计算机、统计学、数学等相关专业本科及以上学历；\n2、具备业务分析基本框架，精通概率统计知识，精通常用数据分析方法，了解数据清洗和数据预处理的常用流程，熟悉关联分析，回归分析，聚类分析等常用分析方法；\n3、有2年以上金融建模经验，熟悉金融业界风控常用的模型和知识，有负责风控模型建模的经验；\n4、精通Python, 熟悉常用统计学模型及机器学习算法，能依照需求独立完成金融建模工作，并具有良好的开发能力；\n5、熟悉SQL、熟悉数据库原理，数据敏感度高, 具有主动积极性，具有较强的学习能力、分析和规划能力；\n6、好奇心强，思路敏捷，探索能力强，对行业数据敏感，有较强的信息筛选、分类、归纳和总结能力；\n7、有良好的数据思维和逻辑推理，优秀的阅读和理解能力，良好的沟通表达能力，能够适应压力，根据工作实际需求调整自身抗压能力。',
    pluses: '1、3年以上商业分析工作经验； \n2、熟悉随机森林，支持向量机，KMEANS, Apriori等常见机器学习算法；\n3、熟悉深度学习算法。'
  },
]

export default data